import { Component, Fragment } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import Navbar from '../../../Components/Navbar';
import Sidebar from '../../../Components/Sidebar';
import ModalResponse from '../../../Components/ModalResponse';
import ModalDestroy from '../../../Components/Destroy';
import { Table } from '../../../Components/Table';
import { getData, deleteData } from "../../../servicos/api";
import { setLoaderShow, setResponseModal, setDestroyModal } from '../../../reducers/index';

import colunas from './colunasTabela';

class Parcela extends Component {

    constructor(props){
        super(props);

        this.state = { 
            parcelas: [],
            uuid: ''
        };

        this.getDataParcela = this.getDataParcela.bind(this);
        this.destroyParcela = this.destroyParcela.bind(this);
        this.loadingShow    = this.loadingShow.bind(this);
    }

    componentDidMount() {
        this.loadingShow(false);
        if( sessionStorage.getItem('uuid_pedido') === null ){
            this.props.history.push('/pedido');
        } else {
            this.getDataParcela();
        }
    }

    // LOADER
    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async getDataParcela(){
        this.loadingShow(true);
        var parcelas = await getData(`/pedido/parcela/${sessionStorage.getItem('uuid_pedido')}`, this.props);
        
        if(parcelas !== null){
            parcelas.map(function (value) {
                value.valor_formatado = `R$ ${value.valor}`;
                value.valor_pago_formatado = `R$ ${value.valor_pago}`;
                value.numero_formatado = `#${value.numero}`;
                return value;
            });
            this.setState({parcelas});
        }
        this.loadingShow(false);
    }

    async destroyParcela(uuid) {
        this.loadingShow(true);
        await deleteData(`/pedido/parcela/${uuid}`, this.props);
        await this.getDataParcela();
        this.loadingShow(false);
    }

    render(){
        let { setResponseModal, enableResponseModal, setDestroyModal, enableDestroyModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <Card>
                                            <CardHeader className="bg-maskats text-center">
                                                <h4 className="headerTitle">Parcelas</h4>
                                            </CardHeader>
                                            <CardBody>
                                                <div>
                                                    <Table
                                                        columns={colunas}
                                                        rows={this.state.parcelas}
                                                        setDestroyModal={setDestroyModal} 
                                                        enableDestroyModal={enableDestroyModal}
                                                        next_url_editar='/pedido/parcela/formulario'
                                                    />
                                                </div>
                                            </CardBody>
                                            <CardFooter className="text-align-end bg-white">
                                                <Link replace to="/pedido">
                                                    <Button className="btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                                                        <i className="fa fa-arrow-left btn-icon-append btn-fs-def text-white"></i>
                                                        <span className="label-button btn-fs-def text-white">Voltar</span>
                                                    </Button>
                                                </Link>
                                                <Link 
                                                    replace
                                                    to={"/pedido/parcela/formulario"}
                                                >
                                                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8 ml-2" type="button">
                                                        <i className="fa fa-plus btn-icon-append btn-fs-def"></i>
                                                        <span className="label-button btn-fs-def">Adicionar</span>
                                                    </Button>
                                                </Link>
                                            </CardFooter>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />

                <ModalDestroy 
                    destroy={this.destroyParcela}
                    setDestroyModal={setDestroyModal} 
                    enableDestroyModal={enableDestroyModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
        enableDestroyModal: state.enableDestroyModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
    setDestroyModal: enable => dispatch(setDestroyModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Parcela);